<template>
  <v-dialog v-model="dialog" max-width="900">
    <v-card>
      <v-card-text>
        <div class="d-flex">
          <v-text-field
            outline
            type="time"
            label="Start from"
            v-model="start"
            style="min-width: 150px; max-width: 150px"
            hide-details
          />
          <v-btn
            @click="calculate"
            color="accent"
            class="ml-auto"
            style="min-width: 250px; max-width: 250px"
            :disabled="detailedList && !start"
          >
            Calculate times
          </v-btn>
        </div>
        <div>
          <v-switch
            v-model="detailedList"
            label="Detailed list"
            :hide-details="detailedList"
          />
          <v-switch
            v-if="detailedList"
            v-model="byProjectMode"
            label="Calculate and split by project for selected items"
            hide-details
          />
          <v-switch
            v-if="byProjectMode && detailedList"
            v-model="singleDayMode"
            label="Calculate into single working day (same developer account)"
          />
        </div>
        <v-textarea
          v-model="text"
          rows="20"
          outline
          @click="copyText"
          ref="text"
          hint="Click into text to copy"
          persistent-hint
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import copy from 'copy-to-clipboard';
export default {
  name: "format-dialog",
  props: {
    times: {
      type: Array,
      default: () => { return [] }
    },
    total: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      start: '00:00',
      text: '',
      dialog: false,
      singleDayMode: false,
      byProjectMode: true,
      detailedList: true
    }
  },
  methods: {
    calculate() {
      if (!this.detailedList) {
        this.calculateForSelectedItems()
        return;
      }

      if (this.byProjectMode) {
        this.calculateByProject()
      } else {
        this.calculateForSelectedItems()
      }
    },
    calculateForSelectedItems() {
      let result = `${moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY')}\n\n`
      result += `${this.times[0].task.project.name}              ${this.total}\n\n`
      let start = moment(this.start, 'HH-mm').format('HH-mm')
      let finish = ''

      if (this.detailedList) {
        this.times.forEach(item => {
          const hours = Math.floor(item.minutes / 60);
          const minutes = item.minutes % 60;

          finish = moment(start, 'HH-mm').add(item.minutes, 'minutes').format('HH-mm')
          result += `${start} — ${finish}    ${hours}h ${minutes}m \n`
          result += `${item.description} \n\n`
          start = finish
        })
        this.text = result
      } else {
        this.times.forEach(item => {
          result += `${item.description} \n`
        })
        this.text = result
      }
    },
    calculateByProject() {
      const groupedByProject = this.times.reduce((acc, item) => {
        const projectName = item.task.project.name;
        if (!acc[projectName]) {
          acc[projectName] = [];
        }
        acc[projectName].push(item);
        return acc;
      }, {});

      let result = `${moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY')}\n\n`
      let start = moment(this.start, 'HH-mm').format('HH-mm')

      Object.entries(groupedByProject).forEach((project, index) => {
        if (index !== 0) {
          result += `\n\n`
        }

        result += `${project[0]}              ${this.total}\n\n`

        if (!this.singleDayMode) {
          start = moment(this.start, 'HH-mm').format('HH-mm')
        }
        let finish = ''

        project[1].forEach(item => {
          const hours = Math.floor(item.minutes / 60);
          const minutes = item.minutes % 60;

          finish = moment(start, 'HH-mm').add(item.minutes, 'minutes').format('HH-mm')
          result += `${start} — ${finish}    ${hours}h ${minutes}m \n`
          result += `${item.description} \n\n`
          start = finish
        })

      })

      this.text = result
    },
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.text = '',
      this.singleDayMode = false
      this.byProjectMode = true
      this.detailedList = true
    },
    copyText() {
      try {
        copy(this.text)
        this.$notify({
          group: 'success',
          type: 'success',
          text: 'Copied'
        })
      } catch(e) {
        throw e
      }
    }
  }
}
</script>
